import TextHandWritingLink from './text';

/**
 * 日本語入力用の directive.link を実現するクラス。
 * 英字入力と違い、１文字入力で複数入力ボックスとなっている。
 * TextHandWritingDirective から派生する。
 * 
 * [依存関係]
 * TextHandWritingLink
 */
export default class JapaneseHandWritingLink extends TextHandWritingLink {
  /**
   * createRegistOption上書き
   * @param {*} scope 
   * @param {*} element 
   * @param {*} attrs 
   * @param {*} ctrl 
   */
  createRegistOption(scope, element, attrs, ctrl) {
    const option = super.createRegistOption(scope, element, attrs, ctrl);
    const iinkParam = option.recognitionParams.iink;

    // カスタム辞書
    iinkParam.text.configuration.customResources = this._getCustomResource();
    iinkParam.text.configuration.addLKText = true;

    // language
    iinkParam.lang = RECOGNITION.language_jp;

    return option;
  }

  _getCustomResource() {
    switch(inputType) {
      case InputType.HandJpKanjiPrimary: return RESOURCES_JAPAN_KANJI_PRIMARY;
      case InputType.HandJpKanjiSecondary: return RESOURCES_JAPAN_KANJI_SECONDARY;
      case InputType.HandJpHiragana: return RESOURCES_HIRAGANA_ONLY;
      case InputType.HandJpKatakana: return RESOURCES_KATAKANA_ONLY;
    }

    return RESOURCES_JAPAN;
  }

  /**
   * 筆跡データを取得する場合は、筆跡取得のためのマウスイベントをセットする$elementを返す。
   * @returns $element
   */
  getStrokeCaptureElement() {
    return this.element.closest('.recognition-box-inner')
  }
}
